import React, {useRef, useState} from 'react';
import { Template } from "../../../components/template/template.jsx";
import "../../../css/style-report.css";
import "../../../css/input-date-time.css";
import {Card} from "../../../components/card/card.jsx";
import Content from "./components/content.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import NoDataContent from "../../../components/reports/report-menu/no-data-content.jsx";
import {useQuery} from "@tanstack/react-query";
import bosService from "../../../services/web/bos-service.js";
import BoTimelineService from "./components/utils/bo-timeline-service.js"
import PrintOptionsModal from "../../../components/print-options-modal/print-options-modal.jsx";

const initialPrintOptions = {
    showResponsible: true,
    showDiff: true,
};

const BoTimeline = () => {
    const [printModal, setPrintModal] = useState(false);
    const [printOptions, setPrintOptions] = useState(initialPrintOptions);
    const [printLoading, setPrintLoading] = useState(false);

    const id = new URLSearchParams(window.top.location.search).get("id");

    const dataId = {id: id.replace('-', '/') ?? null}
    const { data: reportData, isLoading: loading  } = useQuery({
        queryKey: ['bo-timeline-data', dataId],
        queryFn: () => BoTimelineService.apply(dataId),
        initialData: null,
        enabled: !!dataId
    });

    const { data: boData, isLoading: loadingBo } = useQuery({
        queryKey: ['bo-timeline-bo-data', dataId.id],
        queryFn: () => bosService.getBo(dataId.id),
        initialData: null,
        enabled: !!dataId.id
    });

    const currentBoData = boData?.boContent?.bogcm?.bogcm?.data ?? boData?.boContent?.syncs?.[0]?.data?.data;
    const individualList = currentBoData?.individualList ?? [];

    const { data: boName } = useQuery({
        queryKey: ['boName'],
        queryFn: () => bosService.getBoName(),
        initialData: 'BO'
    });

    const title = `Linha do tempo do ${boName} ${dataId.id ?? ''}`;
    const [headerSelected, setHeaderSelected] = useState(-1);

    const printComponentRef = useRef(null);

    const printFields = [
        {
            title: "Detalhes",
            options: [
                {
                    key: "showResponsible",
                    label: "Exibir nome do agente",
                },
                {
                    key: "showDiff",
                    label: "Exibir diferenças nas ações de edição"
                },
            ],
        },
    ];

    return (
        <div className={"flex"}>

            <Template isLoading={loading || loadingBo || printLoading}>
                <Template.Header>
                    <div className="flex justify-between w-full">
                        <Template.Title>{title}</Template.Title>
                        <HeaderButtons
                            printOptions={true}
                            setPrintModal={setPrintModal}
                            printable={true}
                            headerChange={true}
                            printComponentRef={printComponentRef}
                            reportData={reportData?.BOsTimelineAuditorship}
                            data={reportData?.BOsTimelineAuditorship?.length}
                            headerSelected={headerSelected}
                            setHeaderSelected={setHeaderSelected}
                        />
                    </div>
                </Template.Header>
            </Template>

            <Card className={`w-full! mx-auto h-fit ${!reportData?.BOsTimelineAuditorship || reportData?.BOsTimelineAuditorship?.length === 0 ? 'mt-[59px]' : 'mt-[61px] max-w-[1030px]' } print:!mt-[-15px] transform ${!reportData?.BOsTimelineAuditorship || reportData?.BOsTimelineAuditorship?.length === 0 ? '!bg-[#f3f3f4] !border-none !-translate-y-[5px]' : ''}`}>
                <Card.Body>
                    <div className={`flex-1 ${!reportData?.BOsTimelineAuditorship || reportData?.BOsTimelineAuditorship?.length === 0 ? 'p-[0]' : 'py-[5px]'}`}>
                        <NoDataContent reportData={reportData?.BOsTimelineAuditorship} data={reportData?.BOsTimelineAuditorship?.length} customMessage={true}/>
                        <Content reportData={reportData?.BOsTimelineAuditorship} data={reportData?.BOsTimelineAuditorship?.length} boId={dataId?.id} printOptions={printOptions} entity={headerSelected} printComponentRef={printComponentRef} boName={boName} setLoading={setPrintLoading} individualList={individualList}/>
                    </div>
                </Card.Body>
            </Card>

            <PrintOptionsModal
                open={printModal}
                setOpen={setPrintModal}
                printRef={printComponentRef}
                options={printOptions}
                setOptions={setPrintOptions}
                items={printFields}
            />

        </div>
    );
};

export default BoTimeline;